/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import { languageIsEnglish } from "modules/language";
import { gettext } from "modules/django-i18n";

/**
 * Utility function to install new global methods into the Jinja-to-JS runtime.
 *
 * @params {Object} jinjaToJs
 */
export function installJinjaGlobals(jinjaToJs) {
    jinjaToJs.globals._ = gettext;

    jinjaToJs.globals.language_is_english = languageIsEnglish;
}

